import { render, staticRenderFns } from "./Setbank.vue?vue&type=template&id=1c6da195&scoped=true"
import script from "./Setbank.vue?vue&type=script&lang=js"
export * from "./Setbank.vue?vue&type=script&lang=js"
import style0 from "./Setbank.vue?vue&type=style&index=0&id=1c6da195&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6da195",
  null
  
)

export default component.exports